// extracted by mini-css-extract-plugin
export default {"root":"Size__root--3PXzG"};